import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">

      {/* ================= HERO TEXT ================= */}
      <section className="ct-hero">
        <h1>GET IN TOUCH</h1>
        <p>Your next chapter starts with a single step. We're here when you're ready.</p>
      </section>


      {/* ================= GOOGLE MAP ================= */}
      <section className="ct-map-section">
        <iframe
          title="ACE Gym Location"
          className="ct-map"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.086778215312!2d-122.4194152!3d37.7749295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808c77f4a35b%3A0xdbc4fe8e2cf2367!2sGym!5e0!3m2!1sen!2sus!4v1700000000000"
        ></iframe>
      </section>


      {/* ================= INFORMATION BLOCK ================= */}
      <section className="ct-info">

        <div className="ct-info-box">
          <h2>ADDRESS</h2>
          <p>ACE Performance Center<br /> 214 Iron District Lane<br /> Los Angeles, CA 90012</p>
        </div>

        <div className="ct-info-box">
          <h2>HOURS</h2>
          <p>
            Mon–Fri: 5 AM – 11 PM<br />
            Sat: 6 AM – 10 PM<br />
            Sun: 7 AM – 9 PM
          </p>
        </div>

        <div className="ct-info-box">
          <h2>CONTACT</h2>
          <p>
            +1 323 555 0182<br />
            support@acefitness.com<br />
            @ace_training
          </p>
        </div>

      </section>

    </div>
  );
};

export default Contact;
